import type {PropsWithChildren} from 'react'
import {createContext, use, useMemo} from 'react'

interface Props {
  basePageDataUrl: string
}

export const PageDataContext = createContext<Props | null>(null)

export function PageDataContextProvider({children, basePageDataUrl}: PropsWithChildren & Props) {
  const value = useMemo(() => ({basePageDataUrl}), [basePageDataUrl])
  return <PageDataContext value={value}>{children}</PageDataContext>
}

export function usePageDataContext(): Props {
  const contextData = use(PageDataContext)
  if (!contextData) {
    throw new Error('usePageDataContext must be used within a PageDataContextProvider')
  }
  return contextData
}
